import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Preview.css";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import DownloadLink from "../../../util/downloader/DownloadLink";
import CliIcon from "images/sky-music.png";
import {
  Grid,
  Divider,
  Box,
  AppBar,
  Tabs,
  Tab,
  Chip,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Button,
} from "@material-ui/core";
// import trackfields from "../../../_module/definition/trackFields";
import clsx from "clsx";
// import {
//   _mlPlaylists,
//   _mlPlaylistsMetadataConfig,
// } from "../../../_module/definition/MlPlaylists";
import { _PermittedSetting } from "../../../_module/utils/PermittedSetting";
// import {
//   _settingMetadataConditional,
//   _settingMetadataFieldsCommercial,
//   _settingMetadataFieldsCommissioned,
//   _settingMetadataFieldsDefault,
//   _settingMetadataFieldsLibrary,
// } from "../../../_module/definition/SettingMusicMetadata";
import TextElement from "../../../util/preview-element/TextElement";
import TextElementClearance from "../../../util/preview-element/TextElementClearance";
import { loadRuntime } from "../../../redux/actions/ClearanceRuntimeActions";
import { clearDownloads } from "../../../redux/actions/DownloadActions";
import {
  isHeaderQuestion,
  __getNotes,
  __getQuestionAndAnswer,
  __getTrackStatusByID,
} from "../../../_clearance/utils/utils";
import ParamObjectTypes from "../../../_clearance/definition/ParamObjectTypes";
import UserDisplay from "../../../util/UserDisplay";
import moment from "moment";
// import trackField from "../../../_module/definition/trackFields";
import { Link } from "react-router-dom";
import Columns from "./Columns";
import { ColumnTypes } from "../../../util/table-view/TableTypes";
import Moment from "react-moment";
import HelpWrap from "../../ml-admin/help-admin/help-view/HelpWrap";
import { helpModules } from "../../ml-admin/help-admin/help-view/Const";
import genre from "../../../_module/definition/genre";
import {
  NumberDisplay,
  getChangeLogDetails,
  getContributorDetails,
  userDisplay,
} from "../../../util/CommonFunc";
import {
  CFOrgStatus,
  CFOrgStatusLabel,
  PageTableType,
} from "../../../redux/Types";
import {
  getTrackHistory,
  setFocusPreview,
  refreshEdit,
  getCFTrackData,
  loadCollisions,
  updatePrsData,
} from "../../../redux/actions/MlLicFormContentActions";
import DateTimeRenderer from "../../../util/cell-renderer/DateTimeRenderer";
import TrackHistory from "../../../util/history/TrackHistory";
import FormHistory from "../../../util/history/FormHistory";
import { getFormHistory } from "../../../redux/actions/MlLicFormActions";
import HeaderFieldsDisplay from "_clearance/components/wizardv2/HeaderFieldsDisplay";
import OrgUserCFSharedUsers from "util/preview-element/OrgUserCFSharedUsers";
import OrgUserCFSharedGroups from "util/preview-element/OrgUserCFSharedGroups";
import TrackCollisions from "./TrackCollisions";
import PlayerRef from "modules/ml-player/PlayerRef/PlayerRef";
import { AuthSrc } from "util/AuthSrc";
import CliIconMain from "images/artwork.png";
import { MdCheck, MdOutlineClose } from "react-icons/md";
import PrsDataPreview from "util/PrsDataPreview";
import PrsPopup from "_module/component/prs-popup/prs-popup";
import {
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  prsSetHistory,
  CreatePrsTrack,
  CreatePrsManualMatchTrack,
  search,
} from "../../../redux/actions/MlTrackLibraryActions";
import MetadataPopout from "_module/component/metadata-popout/metadata-popout";
import TrackMetadataGrid from "_module/component/track-metadata-grid/track-metadata-grid";
import { DurationDisplayText } from "util/DurationDisplay";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

class Preview extends Component {
  constructor(props) {
    super();
    this.state = {
      tabValue: 0,
      showDetails: false,
      showTrackCollisions: false,
    };
  }

  colsDef = null;
  colsDefAll = null;
  formHistBusy = false;
  trackHistBusy = false;
  trackDatatBusy = false;

  componentDidMount() {
    const {
      runtime: { loading, errors, runtime },
      loadRuntime,
      setFocusPreview,
      clearDownloads,
    } = this.props;
    if (!loading && !runtime && !errors) {
      loadRuntime(null);
    }
    setFocusPreview(0);
    // clearDownloads();
  }

  componentDidUpdate(prevProps) {
    const {
      data: { selectedItem, editing, history, cfTracks },
      runtime: { runtime },
      getTrackHistory,
      getFormHistory,
      cfForm: { history: formHistory },
      setFocusPreview,
      getCFTrackData,
      clearDownloads,
    } = this.props;

    if (prevProps?.data?.selectedItem?.id !== selectedItem?.id) {
      this.setState({
        tabValue: 0,
      });
      // setFocusPreview(0);
      clearDownloads();

      if (
        editing &&
        runtime &&
        runtime._config &&
        editing[runtime._config.MIGRATED_FLAG]
      ) {
        this.renderMigratedHeaderQ();
      }
    }

    if (formHistory && editing && editing.id && !(editing.id in formHistory)) {
      if (!this.formHistBusy) {
        this.formHistBusy = true;
        getFormHistory(editing.id, editing.hybridId, (data, err) => {
          this.formHistBusy = false;
        });
      }
    }
    if (
      editing &&
      editing.id &&
      selectedItem &&
      selectedItem?.trackDetails?.id
    ) {
      if (
        history &&
        !(
          selectedItem.clearanceFormId === editing.id && editing.id in history
        ) &&
        !(
          selectedItem.clearanceFormId !== editing.id &&
          selectedItem.clearanceFormId in history
        )
      ) {
        if (!this.trackHistBusy) {
          this.trackHistBusy = true;
          getTrackHistory(
            selectedItem.clearanceFormId !== editing.id
              ? selectedItem.clearanceFormId
              : editing.id,
            selectedItem?.trackDetails?.id,
            (data, err) => {
              this.trackHistBusy = false;
            }
          );
        }
      } else if (
        history &&
        ((selectedItem.clearanceFormId === editing.id &&
          editing.id in history) ||
          (selectedItem.clearanceFormId !== editing.id &&
            selectedItem?.clearanceFormId in history))
      ) {
        if (
          !(
            history[editing.id] &&
            selectedItem?.trackDetails?.id in history[editing.id]
          ) &&
          !(
            history[selectedItem?.clearanceFormId] &&
            selectedItem?.trackDetails?.id in
            history[selectedItem?.clearanceFormId]
          )
        ) {
          if (!this.trackHistBusy) {
            this.trackHistBusy = true;
            getTrackHistory(
              selectedItem.clearanceFormId !== editing.id
                ? selectedItem.clearanceFormId
                : editing.id,
              selectedItem?.trackDetails?.id,
              (data, err) => {
                this.trackHistBusy = false;
              }
            );
          }
        }
      }

      if (
        editing &&
        runtime &&
        runtime._config &&
        (editing[runtime._config.MIGRATED_FLAG] || editing.hybrid)
      ) {
        // fetching migrated track data
        if (cfTracks && !(editing.id in cfTracks)) {
          if (!this.trackDatatBusy) {
            this.trackDatatBusy = true;
            getCFTrackData(
              editing.id,
              selectedItem?.trackDetails?.id,
              (data, err) => {
                this.trackDatatBusy = false;
              }
            );
          }
        } else if (cfTracks && editing.id in cfTracks) {
          if (!(selectedItem?.trackDetails?.id in cfTracks[editing.id])) {
            if (!this.trackDatatBusy) {
              this.trackDatatBusy = true;
              getCFTrackData(
                editing.id,
                selectedItem?.trackDetails?.id,
                (data, err) => {
                  this.trackDatatBusy = false;
                }
              );
            }
          }
        }
      }
    }
  }

  renderMigratedHeaderQ = () => {
    const {
      data: { editing },
      runtime: { runtime },
    } = this.props;

    let nEditing = { ...editing };
    let headerQs = nEditing?.skyHeaderQuestions || [];
    if (runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST) {
      runtime._config.CF_HEADER_FIELD_LIST.map((field) => {
        let hq = headerQs.find((q) => q.question === field.label);

        if (hq) {
          // if(nEditing.hasOwnProperty(field.id)){
          nEditing[field.id] = hq.answer;
          // }
        }
      });
    }

    refreshEdit({ ...editing, ...nEditing });
  };

  renderMigratedTrackQ = () => {
    const {
      data: { editing },
      runtime: { runtime },
      refreshEdit,
    } = this.props;

    let nEditing = { ...editing };
    let headerQs = nEditing?.skyHeaderQuestions || [];
    if (runtime && runtime._config) {
      runtime._config.CF_HEADER_FIELD_LIST.map((field) => {
        let hq = headerQs.find((q) => q.question === field.label);

        if (hq) {
          // if(nEditing.hasOwnProperty(field.id)){
          nEditing[field.id] = hq.answer;
          // }
        }
      });
    }

    refreshEdit({ ...editing, ...nEditing });
  };

  generateColsDef(origin) {
    const {
      orgRuntime: {
        runtime: {
          _settingMetadataConditional: _settingMetadataConditional,
          _settingMetadataFieldsDefault: _settingMetadataFieldsDefault,
          _settingMetadataFieldsCommercial: _settingMetadataFieldsCommercial,
          _settingMetadataFieldsLibrary: _settingMetadataFieldsLibrary,
          _settingMetadataFieldsCommissioned:
          _settingMetadataFieldsCommissioned,
          _mlMetadata,
          _trackMetadataConfig,
        },
      },
    } = this.props;
    this.colsDefAll = [];
    this.colsDef = [];

    const metaDataSetting = _PermittedContent(
      [_mlMetadata, _trackMetadataConfig],
      []
    ) || { setting: [] };

    this.colsDefAll = this.colsDef =
      _PermittedSetting(
        metaDataSetting.setting,
        _settingMetadataFieldsDefault
      ) || [];

    if (
      _PermittedSetting(metaDataSetting.setting, _settingMetadataConditional) ||
      false
    ) {
      if (origin.startsWith("library")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsLibrary
          ) || this.colsDefAll;
      } else if (origin.startsWith("commercial")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommercial
          ) || this.colsDefAll;
      } else if (origin.startsWith("commissioned")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommissioned
          ) || this.colsDefAll;
      }
    }
  }

  a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  handleTabChange = (event, newValue) => {
    if (!this.props?.isPopOut) {
      const { setFocusPreview } = this.props;
      setFocusPreview(newValue);
    } else {
      this.setState({ tabValue: newValue });
    }
  };

  renderMetadata = (id, i, classes, selectedItem, t, prop, trackField) => {
    let column = Columns[id];
    // let trackField = trackField;
    selectedItem = {
      ...selectedItem,
      ...(selectedItem?.skyMlId ? { id: selectedItem?.skyMlId } : {}),
    };
    let value =
      selectedItem[id] && Array.isArray(selectedItem[id])
        ? selectedItem[id].join(", ")
        : selectedItem[prop?.id]
          ? selectedItem[prop?.id]
          : selectedItem[id];

    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`modules.${id}`)}>
          {t(`modules.${id}`)}
        </label>
        {selectedItem[id] && Array.isArray(selectedItem[id])
          ? selectedItem[id].map((desc, i) => {
            return desc ? <Chip key={i} label={desc} /> : null;
          })
          : selectedItem[id]
            ? selectedItem[id]
            : ""}
      </div>
    ) : (
      <div key={i} className={classes.muDetailWrap}>
        <div
          className={clsx(
            id === "title" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={t(`track.${id}`)}>
          {t(`track.${id}`)}
        </div>
        <div className={classes.muSeperator}> :</div>
        {selectedItem?.trackDetails?.prodId &&
          (id === trackField.prodName.id || id === trackField.catNo.id) ? (
          <div
            className={clsx(
              id === trackField.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {((selectedItem?.trackDetails?.is_mcf_track == true || selectedItem?.trackDetails?.mlCreated == true) ?
              <strong class="tablesLink">{value || ""}</strong> :
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={selectedItem?.trackDetails?.id}
                to={`/search/album/${selectedItem?.trackDetails?.prodId}`}>
                <strong class="tablesLink">{value || ""}</strong>
              </Link>
            )}
          </div>
        ) : id === trackField.duration.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={DurationDisplayText({ seconds: value }) || ""}>
            {DurationDisplayText({ seconds: value }) || ""} 
          </div>
        ) : id == trackField.contributorsExtended.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem?.trackDetails?.contributorsExtended
              ? getContributorDetails(
                selectedItem?.trackDetails?.contributorsExtended
              )
              : ""}
          </div>
        ) : id == trackField.changeLog.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem?.trackDetails?.changeLog
              ? getChangeLogDetails(selectedItem?.trackDetails?.changeLog)
              : ""}
          </div>
        ) : id === trackField.org_sky_prodIsMCPSBlanket.id ||
          id === trackField.org_sky_prodIsPPLBlanket.id ? (
          <div
            className={clsx(
              id === trackField?.prodName?.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {value == true ? (
              ""
            ) : value == false &&
              id === trackField.org_sky_prodIsMCPSBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
            ) : value == false &&
              id === trackField.org_sky_prodIsPPLBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-PPL</span>
            ) : (
              ""
            )}
          </div>
        ) : (id == trackField.org_sky_PPL.id || id === trackField.org_sky_MCPS.id) ? (
          <div
            className={clsx(
              id === trackField?.prodName?.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {/* {value == true ? (
              "No"
            ) : value == false && id === trackField.org_sky_MCPS.id ? (
              // <span className={classes.nonMCPSPPL}>Non-MCPS</span>
              <span className={classes.nonMCPSPPL}>Yes</span>
            ) : value == false &&
              id === trackField.org_sky_PPL.id ? (
              // <span className={classes.nonMCPSPPL}>Non-PPL</span>
              <span className={classes.nonMCPSPPL}>Yes</span>
            ) : (
              ""
            )} */}
             {value == true ? (
              id === trackField.org_sky_MCPS.id ? "No" : selectedItem["pplStatusMigrated"] == true ? "No (manual)" : "No"
            ) : value == false && id === trackField.org_sky_MCPS.id ? (
              <span className={classes.nonMCPSPPL}>Yes</span>
              // <span className={classes.nonMCPSPPL}>Yes</span>
            ) : value == false &&
              id === trackField.org_sky_PPL.id ? (
                selectedItem["pplStatusMigrated"] == true ?
              <span><span className={classes.nonMCPSPPL}>Yes</span> (manual)</span> : <span className={classes.nonMCPSPPL}>Yes</span>
              // <span className={classes.nonMCPSPPL}>Yes</span>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={
              column?.type === ColumnTypes.datetime ||
                column?.type === ColumnTypes.date
                ? null
                : id === trackField.musicOrigin.id
                  ? t(`modules.originLables.${value}`)
                  : value || ""
            }>
            {column?.type === ColumnTypes.datetime ? (
              value ? (
                <Moment
                  format="DD/MM/YYYY h:mm:ss A"
                  titleFormat="DD/MM/YYYY h:mm:ss A"
                  withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.date ? (
              value ? (
                <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                  {value}
                </Moment>
              ) : null
            ) : id === trackField.musicOrigin.id ? (
              t(`modules.originLables.${value}`)
            ) : value === true ? (
              "True"
            ) : value === false ? (
              "False"
            ) : (
              value || ""
            )}
          </div>
        )}
      </div>
    );
  };

  getIpsText = (ipsArray) => {
    try {
      if (Array.isArray(ipsArray)) {
        return ipsArray
          ?.filter((r) => r?.fullName)
          .map((r) => r?.fullName)
          ?.join(", ");
      } else {
        return null;
      }
    } catch {
      return null;
    }
  };

  renderAdminNotes = (selectedItem, classes, t) => {
    return (
      <>
        <div className={classes.muDetailWrap}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Admin Notes`}
            className={classes.muLabels}>
            {`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Admin Notes`}{" "}
          </div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcAdminNotes || ""}>
            {selectedItem?.bbcAdminNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Librarian Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Librarian Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLibrarianNotes || ""}>
            {selectedItem?.bbcLibrarianNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Licence Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Licence Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLicenceNotes || ""}>
            {selectedItem?.bbcLicenceNotes || ""}
          </div>
        </div>
      </>
    );
  };

  getStatus = (id) => {
    const {
      runtime: { loading, runtime },
    } = this.props;
    if (loading) return { name: "", color: "" };
    return __getTrackStatusByID(id, runtime?._statuses || []);
  };

  renderMigratedExtendedFields = (field) => {
    const {
      classes,
      data: { editing },
    } = this.props;

    switch (field?.type) {
      case "obArray":
        if (editing[field.id] && editing[field.id].length > 0) {
          return (
            <TextElement
              label={field.label}
              classes={classes}
              data={
                <>
                  {editing[field.id].map((f) => {
                    return (
                      <div title={""}>
                        <div title={""}>
                          {Object.keys(f).map((key) => {
                            return (
                              <div title={key}>
                                {key} : {f[key]}
                              </div>
                            );
                          })}
                        </div>
                        <br />
                      </div>
                    );
                  })}
                </>
              }
            />
          );
        }
      case "obData":
        let returnElement = (
          <TextElement
            label={field.label}
            classes={classes}
            data={
              field?.parent ? `${editing[field.parent][field.id] ?? ""}` : ""
            }
          />
        );
        return field?.hideIfNotExist
          ? editing[field.parent][field.id]
            ? returnElement
            : ""
          : returnElement;
      case "yesNo":
        return (
          <TextElement
            label={field.label}
            classes={classes}
            data={`${editing[field.id] ? "Yes" : "No" ?? ""}`}
          />
        );
      default:
        return (
          <TextElement
            label={field.label}
            classes={classes}
            data={`${editing[field.id] ?? ""}`}
          />
        );
    }
  };

  render() {
    let selectedItem;
    const {
      runtime: { loading, errors, runtime },
      classes,
      data: {
        selectedItem: selectedItemForPreview,
        editing,
        history,
        activePreview,
        cfTracks,
        cfTracksLoading,
        cfAddEpisodesLoading,
      },
      getTrackHistory,
      getFormHistory,
      prsTrackUnlink,
      prsHistorySearch,
      prsMechanicalOverride,
      prsSetHistory,
      CreatePrsTrack,
      updatePrsData,
      CreatePrsManualMatchTrack,
      search,
      cfForm: { history: formHistory },
      trackLibraryData: {
        PRSHistoryLoading,
      },
      orgRuntime, 
      orgRuntime: {
        runtime: {
          _trackFields: trackfields,
          _mlMetadata,
          _canSeeAdminNotes,
          _extendedTrackPreviewMetadata,
        },
      },
      item,
      allGroups,
      allUsers,
    } = this.props;

    if (this.props?.isPopOut) {
      selectedItem = item;
    } else {
      selectedItem = selectedItemForPreview;
    }

    if (selectedItem && selectedItem?.trackDetails?.id)
      this.generateColsDef(
        (selectedItem[trackfields.musicOrigin.id] || "").toLowerCase()
      );
    const canViewAdminNotes = _PermittedContent(
      [_mlMetadata, _canSeeAdminNotes],
      []
    )
      ? true
      : false;


    return (
      <Translation>
        {(t, { i18n }) => (
          <Paper className={classes.sideBar} role="contentinfo">
            {selectedItem && (selectedItem?.trackDetails?.id || selectedItem?.id) ? (
              <>
                {!this.props?.isPopOut && (
                  <>
                    <Paper className={classes.disFlex}>
                      <h2 className={classes.muTitle}>
                        {selectedItem.trackDetails[trackfields.trackTitle.id] ||
                          t("libraryPreview.na")}
                        <span className={classes.muSubTitle}>
                          {(selectedItem.trackDetails[
                            trackfields.performer.id
                          ] &&
                            Array.isArray(
                              selectedItem.trackDetails[trackfields.performer.id]
                            )
                            ? selectedItem.trackDetails[
                              trackfields.performer.id
                            ].join(", ")
                            : selectedItem.trackDetails[
                            trackfields.performer.id
                            ]) || t("libraryPreview.na")}
                        </span>
                      </h2>
                      <HelpWrap config={helpModules.CFormPWH} />
                      {editing?.id && (
                        <DownloadLink
                          track={{
                            ...selectedItem.trackDetails,
                            ...(selectedItem?.trackDetails?.skyMlId
                              ? { id: selectedItem?.trackDetails?.skyMlId }
                              : {}),
                          }}
                          cfTrackSequenceId={selectedItem?.trackDetails?.id}
                          cfId={editing?.id}
                        />
                      )}
                    </Paper>

                  </>

                )}
                {!this.props?.isPopOut && (<div style={{ display: "flex" }}>
                  <div className={classes.trackEditContainer}>
                    <Paper>
                      <Box className={classes.artworkHolder} tabIndex="-1" p={1}>
                        <Grid
                          container
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                          tabIndex="-1">
                          {selectedItem?.trackDetails[
                            trackfields.prodArtworkUrl.id
                          ] ? (
                            <img
                              style={{ height: 240, width: trackfields }}
                              src={AuthSrc(
                                selectedItem?.trackDetails[
                                trackfields.prodArtworkUrl.id
                                ]
                              )}
                              alt={
                                selectedItem?.trackDetails[
                                trackfields.trackTitle.id
                                ] || ""
                              }
                            />
                          ) : (
                            <Grid
                              container
                              direction="column"
                              alignItems="center"
                              justifyContent="center">
                              {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                              <img
                                className={"emptyArtwork"}
                                style={{ width: 120 }}
                                src={CliIconMain}
                                alt="Sky Music"
                              />
                            </Grid>
                          )}
                        </Grid>
                        {/* {postUpdating ? null :  */}
                        <PlayerRef
                          className={classes.playTrackButton}
                          key={selectedItem?.trackDetails?.id}
                          aria-label="Play"
                          item={{
                            ...selectedItem?.trackDetails,
                            ...(selectedItem?.trackDetails?.skyMlId
                              ? { id: selectedItem?.trackDetails?.skyMlId }
                              : {}),
                          }}
                          popoutFor={PageTableType.SEARCH_TRACKS}
                        />
                        {/* } */}
                      </Box>
                    </Paper>
                  </div>
                  {!this.props?.isPopOut && (
                    <div className={classes.popOutBlock}>

                      {
                        <MetadataPopout
                          popoutFor={PageTableType.CLEARANCE_FORM_TRACKS}
                          data={selectedItem}
                        />
                      }
                      {
                        <PrsPopup
                          prsTrackUnlink={prsTrackUnlink}
                          prsHistorySearch={prsHistorySearch}
                          prsmechanicaloverride={prsMechanicalOverride}
                          PRSHistoryLoading={PRSHistoryLoading}
                          // popoutFor={PageTableType.SEARCH_TRACKS}
                          mbTrackData={selectedItem.trackDetails}
                          prsTrackData={selectedItem?.trackDetails?.prsTrack}
                          updatePrsData={updatePrsData}
                          // trackSearch={() => {
                          //   search(query);
                          // }}
                          prsSetHistory={prsSetHistory}
                          CreatePrsTrack={CreatePrsTrack}
                          popoutFor={PageTableType.CLEARANCE_FORM_TRACKS}
                          // focusItem={focusItem}
                          mlsearch={search}
                          CreatePrsManualMatchTrack={CreatePrsManualMatchTrack}
                        />
                      }
                    </div>
                  )}
                </div>)}
                <AppBar className={classes.trackTabsHeader} position="static">
                  <Tabs
                    // value={this.state.tabValue}
                    value={
                      this.props?.isPopOut ? this.state.tabValue : activePreview
                    }
                    onChange={this.handleTabChange}
                    scrollButtons="auto"
                    variant="scrollable">
                    <Tab label="Clearance" {...this.a11yProps(0)} />
                    <Tab label="Form" {...this.a11yProps(1)} />
                    <Tab label="Metadata" {...this.a11yProps(2)} />
                    <Tab label="PRS" {...this.a11yProps(3)} />
                    <Tab label="History" {...this.a11yProps(4)} />
                    <Tab label="Form History" {...this.a11yProps(5)} />
                    {/* <Tab label="Notes" {...this.a11yProps(2)} /> removed as notes have been moved to respective tabs */}
                  </Tabs>
                </AppBar>

                <TabPanel
                  className={classes.trackTabs}
                  // value={this.state.tabValue}
                  value={
                    this.props?.isPopOut ? this.state.tabValue : activePreview
                  }
                  index={1}>
                  <Paper className={classes.paperwrap}>
                    {editing && (
                      <>
                        <div
                          className={clsx(classes.muListWrap, "popupWindow")}>
                          <TextElement
                            label="ID"
                            classes={classes}
                            data={editing?.id || t("libraryPreview.na")}
                          />
                          {runtime &&
                            runtime._config &&
                            runtime._config.ENABLE_SERIES_HIR ? (
                            <>
                              {/* <TextElement
                                    label="Status"
                                    classes={classes}
                                    showCustomTitle
                                    customTitle={
                                      CFOrgStatusLabel[editing?.status]
                                        ? CFOrgStatusLabel[editing?.status].label
                                        : ""
                                    }
                                    data={
                                      CFOrgStatusLabel[editing?.status] ? (
                                        <span className={classes.cfStatus}>
                                          {" "}
                                          <span
                                            style={{
                                              backgroundColor:
                                                CFOrgStatusLabel[editing.status].color,
                                              width: "17px",
                                              height: "17px",
                                              borderRadius: "50%",
                                              display: "inline-block",
                                              verticalAlign: "middle",
                                              marginRight: "5px",
                                            }}
                                          ></span>
                                          {CFOrgStatusLabel[editing.status].label}{" "}
                                        </span>
                                      ) : (
                                        <span className={classes.cfStatus}></span>
                                      )
                                    }
                                  /> */}
                              <HeaderFieldsDisplay
                                cf={editing}
                                gridColumns={1}
                                trimLabels={true}
                                questionCharLenth={40}
                                isPreviewPanel={true}
                                classes={classes}
                              />
                              {(editing &&
                                runtime &&
                                runtime._config &&
                                (editing[runtime._config.MIGRATED_FLAG]) &&
                                runtime._config.EXTENDED_META_FIELDS?.length >
                                0) && (
                                  <>
                                    {runtime._config.EXTENDED_META_FIELDS.map(
                                      (extField) => {
                                        return this.renderMigratedExtendedFields(
                                          extField
                                        );
                                      }
                                    )}
                                  </>
                                )}
                            </>
                          ) : (
                            <>
                              <TextElement
                                label={t("clearance.cfName")}
                                classes={classes}
                                data={editing?.name || t("libraryPreview.na")}
                              />
                              <TextElement
                                label="GENRE"
                                classes={classes}
                                data={
                                  (editing?.genre
                                    ? Object.keys(genre)
                                      .map((key) => genre[key])
                                      .filter(
                                        (gnre) => gnre.id == editing.genre
                                      )[0]?.label
                                    : "") || t("libraryPreview.na")
                                }
                              />
                              {/* <TextElement
                                  label="Status"
                                  classes={classes}
                                  showCustomTitle
                                  customTitle={
                                    CFOrgStatusLabel[editing?.status]
                                      ? CFOrgStatusLabel[editing?.status].label
                                      : ""
                                  }
                                  data={
                                    CFOrgStatusLabel[editing?.status] ? (
                                      <span className={classes.cfStatus}>
                                        {" "}
                                        <span
                                          style={{
                                            backgroundColor:
                                              CFOrgStatusLabel[editing.status].color,
                                            width: "17px",
                                            height: "17px",
                                            borderRadius: "50%",
                                            display: "inline-block",
                                            verticalAlign: "middle",
                                            marginRight: "5px",
                                          }}
                                        ></span>
                                        {CFOrgStatusLabel[editing.status].label}{" "}
                                      </span>
                                    ) : (
                                      <span className={classes.cfStatus}></span>
                                    )
                                  }
                                /> */}
                              <TextElement
                                label="Music Rights Contact"
                                classes={classes}
                                data={
                                  userDisplay(editing?.allocatedUser) ||
                                  t("libraryPreview.na")
                                }
                              />
                              <TextElement
                                label="Ref No"
                                classes={classes}
                                data={editing?.refNo || t("libraryPreview.na")}
                              />
                              <TextElement
                                label="Deadline"
                                classes={classes}
                                data={
                                  editing.deadline ? (
                                    <Moment
                                      format="DD/MM/YYYY"
                                      titleFormat="DD/MM/YYYY"
                                      withTitle>
                                      {editing.deadline}
                                    </Moment>
                                  ) : (
                                    t("libraryPreview.na") ||
                                    t("libraryPreview.na")
                                  )
                                }
                              />

                              <TextElement
                                label="Service"
                                classes={classes}
                                data={editing.service}
                              />
                              <TextElement
                                label="Service Group"
                                classes={classes}
                                data={editing.serviceGroup}
                              />

                              <TextElement
                                label="Synopsis"
                                classes={classes}
                                data={
                                  editing?.synopsis || t("libraryPreview.na")
                                }
                              />

                              <TextElement
                                label="Notes"
                                classes={classes}
                                data={editing?.notes || t("libraryPreview.na")}
                              />

                              <TextElement
                                label="NO. OF TRACKS"
                                classes={classes}
                                data={editing?.clearance?.tracks.length || 0}
                              />

                              <OrgUserCFSharedUsers
                                label="Shared Users"
                                classes={classes}
                                data={editing?.sharedUsers}
                                allUsers={allUsers}
                              />
                              <OrgUserCFSharedGroups
                                label="Shared Groups"
                                classes={classes}
                                data={editing?.sharedGroups}
                                orgGroups={allGroups}
                              />

                              <TextElement
                                label="CREATED BY"
                                classes={classes}
                                data={
                                  <UserDisplay userId={editing?.createdBy} /> ||
                                  t("libraryPreview.na")
                                }
                              />

                              <TextElement
                                label="DATE CREATED"
                                classes={classes}
                                data={
                                  editing.createdAt ? (
                                    <Moment
                                      format="DD/MM/YYYY h:mm:ss A"
                                      titleFormat="DD/MM/YYYY h:mm:ss A"
                                      withTitle>
                                      {editing.createdAt}
                                    </Moment>
                                  ) : (
                                    t("libraryPreview.na") ||
                                    t("libraryPreview.na")
                                  )
                                }
                              />

                              <TextElement
                                label="UPDATED BY"
                                classes={classes}
                                data={
                                  <UserDisplay userId={editing?.updatedBy} /> ||
                                  t("libraryPreview.na")
                                }
                              />
                              <TextElement
                                label="DATE UPDATE"
                                classes={classes}
                                data={
                                  editing.updatedAt ? (
                                    <Moment
                                      format="DD/MM/YYYY h:mm:ss A"
                                      titleFormat="DD/MM/YYYY h:mm:ss A"
                                      withTitle>
                                      {editing.updatedAt}
                                    </Moment>
                                  ) : (
                                    t("libraryPreview.na") ||
                                    t("libraryPreview.na")
                                  )
                                }
                              />
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </Paper>
                </TabPanel>

                <TabPanel
                  className={classes.trackTabs}
                  // value={this.state.tabValue}
                  value={
                    this.props?.isPopOut ? this.state.tabValue : activePreview
                  }
                  index={0}>
                  <Paper className={classes.paperwrap}>
                    <div className={clsx(classes.muListWrap, "popupWindow")}>
                      {runtime?._config?.CF_TRACK_ORG_STATUS?.LICENSED &&
                        +selectedItem.clearancestatus ===
                        +runtime?._config?.CF_TRACK_ORG_STATUS.LICENSED && (
                          <>
                            {selectedItem?.licensingInfoList &&
                              selectedItem?.licensingInfoList?.length > 0 && (
                                <>
                                  <TextElementClearance
                                    label="Budget / Fee"
                                    classes={classes}
                                    showCustomTitle
                                    customTitle={"Budget / Fee"}
                                    data={
                                      <>
                                        {selectedItem.licensingInfoList.map(
                                          (d) => {
                                            return (
                                              <div title={d.licensingName}>
                                                <div class="grayContainer">
                                                  <div class="licFee licFeeFullView">
                                                    {" "}
                                                    <NumberDisplay
                                                      value={d.budget}
                                                    />{" "}
                                                  </div>
                                                  <div
                                                    class="licName licNameFullView"
                                                    title={d.licensingName}>
                                                    {d.licensingName}
                                                    <span>
                                                      {" "}
                                                      {
                                                        (
                                                          runtime?._config
                                                            ?.CF_LICENSING_TYPE_LIST ||
                                                          []
                                                        ).find(
                                                          (k) =>
                                                            k.value ===
                                                            d.licensingType
                                                        )?.label
                                                      }{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )}
                                      </>
                                    }
                                  />
                                </>
                              )}
                            {selectedItem.licensingInfoNotes && (
                              <TextElement
                                label="Notes (License)"
                                classes={classes}
                                data={selectedItem.licensingInfoNotes || "N/A"}
                              />
                            )}
                            {selectedItem.societyIndicatorMcps && (
                              <TextElement
                                label="MCPS"
                                classes={classes}
                                data={
                                  selectedItem.societyIndicatorMcps
                                    ? (
                                      runtime?._config
                                        ?.CF_SI_MCPS_TYPE_LIST || []
                                    ).find(
                                      (k) =>
                                        k.value ===
                                        +selectedItem.societyIndicatorMcps
                                    )?.label
                                    : "N/A"
                                }
                              />
                            )}
                            {selectedItem.societyIndicatorPpl && (
                              <TextElement
                                label="PPL"
                                classes={classes}
                                data={
                                  selectedItem.societyIndicatorPpl
                                    ? (
                                      runtime?._config?.CF_SI_PPL_TYPE_LIST ||
                                      []
                                    ).find(
                                      (k) =>
                                        k.value ===
                                        +selectedItem.societyIndicatorPpl
                                    )?.label
                                    : "N/A"
                                }
                              />
                            )}
                          </>
                        )}
                      {selectedItem.clearanceFormId === editing?.id ? (
                        ""
                      ) : (
                        <TextElement
                          label="Is Master"
                          classes={classes}
                          data={
                            <Link
                              aria-label={`Navigate to series master form`}
                              key={selectedItem.clearanceFormId}
                              to={`/mllicensingforms/${selectedItem.clearanceFormId}`}>
                              <span
                                title="Series Master"
                                className="seriesIndicator">
                                S
                              </span>
                            </Link>
                          }
                        />
                      )}
                      <TextElementClearance
                        label="Status"
                        classes={classes}
                        showCustomTitle={true}
                        customTitle={
                          loading || !runtime
                            ? ""
                            : __getTrackStatusByID(
                              selectedItem.clearancestatus,
                              runtime._statuses
                            ).name || "NA"
                        }
                        data={
                          loading || !runtime ? (
                            <CircularProgress />
                          ) : __getTrackStatusByID(
                            selectedItem.clearancestatus,
                            runtime._statuses
                          ).name ? (
                            <>
                              <span
                                className={classes.clearanceTrafficContainer}>
                                {__getTrackStatusByID(
                                  selectedItem.clearancestatus,
                                  runtime._statuses
                                )?.color != 0 && (
                                    <span
                                      style={{
                                        background: loading
                                          ? ""
                                          : __getTrackStatusByID(
                                            selectedItem.clearancestatus,
                                            runtime._statuses
                                          ).color,
                                      }}
                                      className={
                                        classes.clearanceTrafficLight
                                      }></span>
                                  )}
                                {
                                  __getTrackStatusByID(
                                    selectedItem.clearancestatus,
                                    runtime._statuses
                                  ).name
                                }
                              </span>
                              {runtime?._config?.COLLISIONS &&
                                !isNaN(selectedItem.clearancestatus) &&
                                +selectedItem.clearancestatus ===
                                runtime._config.COLLISIONS.cfTrackStatus &&
                                selectedItem.collision && (
                                  <TrackCollisions
                                    iconView={false}
                                    classes={classes}
                                    props={{ ...this.props }}
                                  />
                                )}
                            </>
                          ) : (
                            "NA"
                          )
                        }
                      />

                      {(selectedItem.adminOverridden || selectedItem.userOverridden) ? (
                        <>
                          <TextElementClearance
                            label={`${selectedItem.adminOverridden ? 'Admin' : 'User'} Overridden by`}
                            classes={classes}
                            data={
                              <UserDisplay userId={selectedItem.adminOverridden && selectedItem.adminOverriddenBy?selectedItem.adminOverriddenBy:selectedItem.updatedBy} />
                            }
                          />

                          {Boolean(selectedItem.adminOverridden) &&
                            <TextElementClearance
                              label="With Notes"
                              classes={classes}
                              data={
                                selectedItem.adminOverriddenWithNotes ||
                                t("libraryPreview.na")
                              }
                            />}
                        </>
                      ) : (
                        <>
                          <TextElementClearance
                            boldLabel={true}
                            label="Track Notes"
                            classes={classes}
                            data={
                              selectedItem?.trackNotes &&
                                Array.isArray(selectedItem?.trackNotes) &&
                                selectedItem?.trackNotes.length > 0
                                ? selectedItem?.trackNotes.map((v, i) => {
                                  return (
                                    <div>
                                      {i + 1} - {v}
                                    </div>
                                  );
                                })
                                : t("libraryPreview.na")
                            }
                            showCustomTitle
                            customTitle={
                              selectedItem?.trackNotes &&
                                Array.isArray(selectedItem?.trackNotes)
                                ? selectedItem?.trackNotes.map((v, i) => {
                                  return `${i + 1} - ${v}`;
                                })
                                : selectedItem?.trackNotes ||
                                t("libraryPreview.na")
                            }
                          />

                          {/* migrated header And Track questions */}
                          {editing &&
                            runtime &&
                            runtime._config &&
                            (editing[runtime._config.MIGRATED_FLAG] || (editing.hybrid && selectedItem?.hybrid)) ? (
                            <>
                              <TextElementClearance
                                label="MCPS"
                                classes={classes}
                                data={
                                  selectedItem.societyIndicatorMcps
                                    ? (
                                      runtime?._config
                                        ?.CF_SI_MCPS_TYPE_LIST || []
                                    ).find(
                                      (k) =>
                                        k.value ===
                                        +selectedItem.societyIndicatorMcps
                                    )?.label
                                    : "N/A"
                                }
                              />
                              <TextElementClearance
                                label="PPL"
                                classes={classes}
                                data={
                                  selectedItem.societyIndicatorPpl
                                    ? (
                                      runtime?._config?.CF_SI_PPL_TYPE_LIST ||
                                      []
                                    ).find(
                                      (k) =>
                                        k.value ===
                                        +selectedItem.societyIndicatorPpl
                                    )?.label
                                    : "N/A"
                                }
                              />
                              {editing?.skyHeaderQuestions?.length > 0 &&
                                editing?.skyHeaderQuestions.map((hq) => {
                                  return (
                                    <TextElementClearance
                                      label={hq.question}
                                      classes={classes}
                                      labelStyle={{
                                        color: "#FFC116",
                                      }}
                                      style={{
                                        color: "#FFC116",
                                      }}
                                      data={hq.answer}
                                    />
                                  );
                                })}
                              {/* migrated track questions */}
                              {editing &&
                                editing.id &&
                                selectedItem &&
                                selectedItem?.trackDetails?.id &&
                                selectedItem?.hybrid
                                ? (
                                  <>
                                    {selectedItem.skyTrackQuestions?.length &&
                                      selectedItem.skyTrackQuestions.map((tq) => {
                                        return (
                                          <TextElementClearance
                                            label={tq.question}
                                            classes={classes}
                                            labelStyle={{
                                              color: "#00DCFF",
                                            }}
                                            style={{
                                              color: "#00DCFF",
                                            }}
                                            data={tq.answer}
                                          />
                                        );
                                      })
                                    }
                                  </>)
                                : (
                                  <>
                                    {selectedItem?.sequenceId &&
                                      editing?.tracks?.find(
                                        (d) =>
                                          d.trackDetails.id ===
                                          selectedItem?.trackDetails?.id &&
                                          d.sequenceId === selectedItem?.sequenceId
                                      )?.skyTrackQuestions?.length > 0 &&
                                      editing?.tracks
                                        ?.find(
                                          (d) =>
                                            d.trackDetails.id ===
                                            selectedItem?.trackDetails?.id &&
                                            d.sequenceId === selectedItem?.sequenceId
                                        )
                                        ?.skyTrackQuestions.map((tq) => {
                                          return (
                                            <TextElementClearance
                                              label={tq.question}
                                              classes={classes}
                                              labelStyle={{
                                                color: "#00DCFF",
                                              }}
                                              style={{
                                                color: "#00DCFF",
                                              }}
                                              data={tq.answer}
                                            />
                                          );
                                        })
                                    }
                                  </>
                                )
                              }
                            </>
                          ) : (
                            <>
                              {(
                                (editing?.clearance?.commits || [])[
                                  selectedItem?.trackDetails?.id
                                ]?.next || []
                              )
                                .sort((a, b) => {
                                  if (
                                    isHeaderQuestion(a) &&
                                    isHeaderQuestion(b)
                                  )
                                    return 0;
                                  else if (isHeaderQuestion(a)) return -1;
                                  else return 1;
                                })
                                .map((v, i) => {
                                  let qa = __getQuestionAndAnswer(
                                    editing?.clearance || {},
                                    v,
                                    selectedItem?.trackDetails?.id
                                  );
                                  return (
                                    <TextElementClearance
                                      label={qa.q}
                                      classes={classes}
                                      labelStyle={{
                                        color: qa.h ? "#FFC116" : "#00DCFF",
                                      }}
                                      style={{
                                        color: qa.h ? "#FFC116" : "#00DCFF",
                                      }}
                                      data={qa.a}
                                    />
                                  );
                                })}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </Paper>
                </TabPanel>

                <TabPanel
                  className={classes.trackTabs}
                  // value={this.state.tabValue}
                  value={
                    this.props?.isPopOut ? this.state.tabValue : activePreview
                  }
                  index={2}>
                  {!this.props?.isPopOut ?
                    <Paper className={classes.paperwrap}>
                     {/*  {editing?.clearance?.tLookup?.find(
                        (d) => d.id == selectedItem?.trackDetails?.id
                      ) ? ( */}
                        <div className={clsx(classes.muListWrap, "popupWindow")}>
                          {this.colsDefAll?.map((id, i) => {
                            const prop = trackfields[id] || {};
                            return this.renderMetadata(
                              id,
                              i,
                              classes,
                              selectedItem.trackDetails,
                              t,
                              prop,
                              trackfields
                            );
                          })}
                          {canViewAdminNotes &&
                            this.renderAdminNotes(
                              selectedItem.trackDetails,
                              classes,
                              t
                            )}
                        </div>
                      {/* ) : (
                        <CircularProgress className={classes.clearanceLoader} />
                      )} */}
                    </Paper>
                    :
                    (<TrackMetadataGrid data={item.trackDetails} classes={classes} />)
                     }

                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={
                    this.props?.isPopOut ? this.state.tabValue : activePreview
                  }
                  index={3}>
                  <Paper className={classes.paperwrap}>
                    <div className={clsx(classes.muListWrap, "popupWindow")}>
                      <PrsDataPreview
                        classes={classes}
                        selectedItem={selectedItem?.trackDetails}
                      />
                    </div>
                  </Paper>
                </TabPanel>

                <TabPanel
                  className={classes.trackTabs}
                  // value={this.state.tabValue}
                  value={
                    this.props?.isPopOut ? this.state.tabValue : activePreview
                  }
                  index={4}>
                  <Paper className={classes.paperwrap}>
                    <div className={clsx(classes.muListWrap, "popupWindow")}>
                      {editing && !editing.id ? (
                        <div class={classes.noData}> No History</div>
                      ) : editing && history ? (
                        <>
                          <>
                            {runtime &&
                              runtime._config &&
                              !editing[runtime._config.MIGRATED_FLAG] && (
                                <FormControlLabel
                                  className={classes.clearanceCheckBoxFormRight}
                                  control={
                                    <Checkbox
                                      checked={this.state.showDetails}
                                      className={classes.clearanceCheckBox}
                                      onChange={() => {
                                        this.setState({
                                          showDetails: !this.state.showDetails,
                                        });
                                      }}
                                      inputProps={{
                                        "aria-label": "Details on/off",
                                      }}
                                    />
                                  }
                                  label={
                                    !this.state.showDetails
                                      ? "Show Details"
                                      : "Hide Details"
                                  }
                                />
                              )}
                          </>
                          {history &&
                            editing?.id &&
                            ((selectedItem.clearanceFormId === editing.id &&
                              editing.id in history) ||
                              (selectedItem.clearanceFormId !== editing.id &&
                                selectedItem?.clearanceFormId in history)) ? (
                            <>
                              {history &&
                                history[
                                selectedItem.clearanceFormId !== editing.id
                                  ? selectedItem.clearanceFormId
                                  : editing.id
                                ] &&
                                selectedItem?.trackDetails?.id &&
                                selectedItem?.trackDetails?.id in
                                history[
                                selectedItem.clearanceFormId !== editing.id
                                  ? selectedItem.clearanceFormId
                                  : editing.id
                                ] ? (
                                history[
                                  selectedItem.clearanceFormId !== editing.id
                                    ? selectedItem.clearanceFormId
                                    : editing.id
                                ][selectedItem?.trackDetails?.id].length ==
                                  0 ? (
                                  <div class={classes.noData}> No History</div>
                                ) : (
                                  <>
                                    <TrackHistory
                                    orgRuntime={orgRuntime}
                                      showDetails={this.state.showDetails}
                                      data={
                                        history[
                                        selectedItem.clearanceFormId !==
                                          editing.id
                                          ? selectedItem.clearanceFormId
                                          : editing.id
                                        ][selectedItem?.trackDetails?.id]
                                      }
                                      classes={classes}
                                      getStatus={(id) => this.getStatus(id)}
                                      migrated={
                                        (editing &&
                                          runtime &&
                                          runtime._config &&
                                          editing[
                                          runtime._config.MIGRATED_FLAG
                                          ]) ||
                                        false
                                      }
                                    />
                                  </>
                                )
                              ) : (
                                <CircularProgress
                                  className={classes.clearanceLoader}
                                />
                              )}
                            </>
                          ) : (
                            <CircularProgress
                              className={classes.clearanceLoader}
                            />
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Paper>
                </TabPanel>

                <TabPanel
                  className={classes.trackTabs}
                  // value={this.state.tabValue}
                  value={
                    this.props?.isPopOut ? this.state.tabValue : activePreview
                  }
                  index={5}>
                  <Paper className={classes.paperwrap}>
                    <div className={clsx(classes.muListWrap, "popupWindow")}>
                      {editing && !editing.id ? (
                        <div class={classes.noData}> No History</div>
                      ) : formHistory &&
                        editing &&
                        editing.id &&
                        editing.id in formHistory ? (
                        formHistory[editing.id].length == 0 ? (
                          <div class={classes.noData}> No History</div>
                        ) : (
                          <FormHistory
                            orgRuntime={orgRuntime}
                            data={formHistory[editing.id]}
                            classes={classes}
                            getStatus={(id) => this.getStatus(id)}
                            migrated={
                              (editing &&
                                runtime &&
                                runtime._config &&
                                editing[runtime._config.MIGRATED_FLAG]) ||
                              false
                            }
                          />
                        )
                      ) : (
                        <CircularProgress />
                      )}
                    </div>
                  </Paper>
                </TabPanel>
              </>
            ) : (
              <div className={classes.noData}>
                {/* <MusicNoteIcon style={{ fontSize: 60, marginBottom: 20 }} /> */}
                <img
                  className={"emptyArtwork"}
                  style={{ width: 120 }}
                  src={CliIcon}
                  alt="Sky Music"
                />
                {/* {t("libraryPreview.noPreview")} */}
              </div>
            )}
          </Paper>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mllicformcontent,
  trackLibraryData: state.mltracklibrary,
  runtime: state.clearanceRuntime,
  cfForm: state.mllicform,
  allUsers: state.inbox.allUsers,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  loadRuntime,
  getTrackHistory,
  getFormHistory,
  setFocusPreview,
  refreshEdit,
  getCFTrackData,
  clearDownloads,
  loadCollisions,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  prsSetHistory,
  CreatePrsTrack,
  updatePrsData,
  CreatePrsManualMatchTrack,
  search,
})(withStyles(styles)(Preview));
